import { IonAlert, IonButton, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { peopleOutline } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";

export default function ProfilePage() {
  const { session, logout } = useAuth();
  const history = useHistory();
  const [isSignOutOpen, setIsSignOutOpen] = useState(false);
  const profile = session?.admin || session?.user;
  const appVersion = import.meta.env.VITE_APP_VERSION || "dev";

  function signOut() {
    logout();
    history.replace("/login");
  }

  function renderRole() {
    const words = session?.role?.split("_") || [];
    const role = words.map((r) => r.charAt(0).toUpperCase() + r.slice(1).toLowerCase()).join(" ");

    return `Role: ${role}`;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Profile</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <main className="page-pad">
          <section className="panel">
            <h2>{profile?.name || "Metora User"}</h2>
            <p>{profile?.email || profile?.employeeNumber || session?.role}</p>
            <p>{renderRole()}</p>
            <p className="app-version">App version {appVersion}</p>
            <div className="profile-actions">
              {session?.role === "admin" && (
                <IonButton expand="block" fill="outline" onClick={() => history.push("/app/profile/teams")}>
                  <IonIcon icon={peopleOutline} slot="start" />
                  My Teams
                </IonButton>
              )}
              <IonButton expand="block" color="danger" onClick={() => setIsSignOutOpen(true)}>
                Sign Out
              </IonButton>
            </div>
          </section>
        </main>
        <IonAlert
          cssClass="metora-alert"
          isOpen={isSignOutOpen}
          header="Sign Out"
          message="Are you sure you want to sign out?"
          buttons={[
            {
              text: "Cancel",
              role: "cancel",
            },
            {
              text: "Sign Out",
              role: "destructive",
              handler: signOut,
              cssClass: "status-progress",
            },
          ]}
          onDidDismiss={() => setIsSignOutOpen(false)}
        />
      </IonContent>
    </IonPage>
  );
}
